import db from "../../db";
import { getCurrentDate } from "../../time";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import { throwErrorMessage, throwSuccessMessage } from "../../lib/error_helper";
import { MYOPEN, KEYSTONE, EXTRANET } from "../../constants";
import { CHANGE_PASSWORD_MESSAGE, SET_ALL_USERS } from './usersConstants'
import { checkEmailFormat } from "../../utils";
import { getSites } from "../customerSite/customerSiteActions";
import { loadLoggedEmployee } from "../employees/loggedEmployeeActions";

export function authenticateUserHasErrored(bool) {
	return {
		type: "AUTHENTICATE_USER_HAS_ERRORED",
		hasErrored: bool,
	};
}

export function userIsLoading(bool) {
	return {
		type: "IS_LOADING",
		isLoading: bool,
	};
}

export function authenticateUserSuccess(user) {
	return {
		type: "AUTHENTICATE_USER_SUCCESS",
		user,
	};
}

export function setAllUsersAction(users) {
	return {
		type: SET_ALL_USERS,
		users
	}
}

export function setChangePasswordMessageAction(changePasswordMessage) {
	return {
		type: CHANGE_PASSWORD_MESSAGE,
		changePasswordMessage
	}
}

export function getUserByEMail(_email) {
	return db.User.where({ email: _email }).first();
}

export function addUser(user) {
	db.User.add(user);
	return user;
}

export function deleteUser(user) {
	db.User.delete(user.email);
}

export function createUser(user, _date_connection, application) {
	user.date_connection = _date_connection;
	user.application = application;
	return user;
}

export function generateName(user) {
	let name = "";

	if (user.first_name) {
		name = name.concat(user.first_name)
	}

	if (user.last_name) {
		if (user.first_name)
			name = name.concat(" ");

		name = name.concat(user.last_name);
	}

	return name;
}

export function authenticateUser(email, googleToken, getSynchroActiveUser, getDefaultSyncState, getAllData) {
	return (dispatch) => {
		dispatch(userIsLoading(true));
		const headers = new Headers({ "Content-Type": "application/json" });
		const body = JSON.stringify({ email: email, googleToken });
		fetchWithTimeout("/api/user/authenticate", {
			method: "POST",
			headers: headers,
			body: body,
		})
			.then((response) => {
				dispatch(userIsLoading(false));

				if (!response.ok) {
					throw Error(response.statusText);
				}
				return response.json();
			})
			.then((authenticationDatas) => {
				let user = authenticationDatas.user;
				localStorage.setItem("userToken", authenticationDatas.token);

				user.name = generateName(user);

				user.email = email;

				getUserByEMail(user.email).then((existingUser) => {
					if (existingUser !== undefined) {
						deleteUser(existingUser);
					}

					let newUser = addUser(createUser(user, getCurrentDate(), MYOPEN));

					dispatch(authenticateUserSuccess(newUser));
					dispatch(loadActiveUser());
					dispatch(getAllData());
					dispatch(loadLoggedEmployee(user.id, user.emp_id, false, true));
				});
			})
			.catch((err) => {
				console.error("Erreur : usersActions - authenticateUser", err);
				dispatch(userIsLoading(false));

				dispatch(
					throwErrorMessage({
						errorObject: err,
						title: "Erreur",
						message: "Une erreur s'est produite lors de la connexion !",
					})
				);
				dispatch(authenticateUserHasErrored(true));
			});
	};
}

export function authenticateExternalUser(login, password, getSynchroActiveUser, getDefaultSyncState, isExtranetApp) {
	return (dispatch) => {
		if (!checkEmailFormat(login)) {
			dispatch(
				throwErrorMessage({
					title: "Erreur",
					message: "L'identifiant doit-être sous forme d'adresse mail",
				})
			);

			return;
		}

		dispatch(userIsLoading(true));
		const headers = new Headers({ "Content-Type": "application/json" });
		const body = JSON.stringify({ login, password });
		fetchWithTimeout("/api/user/external_authenticate", {
			method: "POST",
			headers: headers,
			body: body,
		})
			.then((response) => {
				dispatch(userIsLoading(false));

				if (!response.ok) {
					if (response.status === 429) {
						dispatch(
							throwErrorMessage({
								errorObject: response,
								title: "Erreur",
								message: "Connexion bloquée car trop de tentatives répétées ont eu lieues. Veuillez réessayer plus tard",
							})
						);

						console.error("Erreur : usersActions - authenticateExternalUser", response);
					}

					throw Error(response.statusText);
				}
				return response.json();
			})
			.then((authenticationDatas) => {
				let user = authenticationDatas.user;
				localStorage.setItem("userToken", authenticationDatas.token);

				user.name = generateName(user);

				getUserByEMail(user.email).then((existingUser) => {
					if (existingUser !== undefined) {
						deleteUser(existingUser);
					}

					let newUser = addUser(
						createUser(user, getCurrentDate(), isExtranetApp ? EXTRANET : KEYSTONE)
					);

					dispatch(authenticateUserSuccess(newUser));
					dispatch(loadActiveUser((user) => {
						if (user && isExtranetApp)
							dispatch(getSites(user.id));
					}));
				});
			})
			.catch((err) => {
				console.error("Erreur : usersActions - authenticateExternalUser", err);
				dispatch(userIsLoading(false));

				dispatch(
					throwErrorMessage({
						errorObject: err,
						title: "Erreur",
						message: "Une erreur s'est produite lors de la connexion !",
					})
				);
			});
	};
}

export function getUserToken() {
	return localStorage.getItem("userToken");
}

export function loadActiveUser(onSuccess) {
	return (dispatch) => {
		db.User.limit(1)
			.first()
			.then((user) => {
				dispatch({ type: "GET_ACTIVE_USER", user: user });
				if (onSuccess && typeof onSuccess === "function")
					onSuccess(user);
			});
	};
}

export function getActiveUser() {
	return db.User.limit(1)
		.first()
		.then((user) => {
			return user;
		});
}

export function getActiveUserNoDispatch() {
	return db.User.limit(1).first();
}

export function clearUserToken() {
	localStorage.setItem("userToken", "");
}

export function clearUsers() {
	return (dispatch) => {
		db.User.clear().then(() => {
			dispatch({ type: "CLEAR_USERS" });
		});
		clearUserToken();
		dispatch(loadActiveUser());
	};
}

export function getAllUsers(user) {
	return (dispatch) => {
		dispatch(userIsLoading(true));

		const headers = new Headers({ "Content-Type": "application/json" });
		fetchWithTimeout("/api/v1/user/get_site_monitoring_users", {
			method: "POST",
			headers: headers,
			timeout: 60000,
			body: JSON.stringify({
				userId: user.id,
			}),
		})
			.then((response) => {
				if (!response.ok) throw Error(response.statusText);

				return response;
			})
			.then((response) => response.json())
			.then((allUsers) => {
				dispatch(setAllUsersAction(allUsers));
				dispatch(userIsLoading(false));
			});
	};
}

export function requestNewPasswordByMail(login) {
	return (dispatch) => {
		dispatch(userIsLoading(true));
		const headers = new Headers({ "Content-Type": "application/json" });
		const body = JSON.stringify({ login });
		fetchWithTimeout("/api/user/requestNewPasswordByMail", {
			method: "POST",
			headers: headers,
			body: body,
		})
			.then((response) => {
				dispatch(userIsLoading(false));

				if (!response.ok) {
					throw Error(response.statusText);
				}
				return response.json();
			})
			.then(() => {
				dispatch(
					throwSuccessMessage({
						title: "Le mail ne devrait pas tarder à arriver dans votre boite mail",
					})
				);
			})
			.catch((err) => {
				console.error("Erreur : usersActions - requestNewPasswordByMail", err);
				dispatch(userIsLoading(false));

				dispatch(
					throwErrorMessage({
						errorObject: err,
						title: "Erreur",
						message: "Une erreur s'est produite lors de la demande de mot de passe oublié !",
					})
				);
			});
	}
}

export function validatePasswordChange(token) {
	return (dispatch) => {
		dispatch(userIsLoading(true));
		const headers = new Headers({ "Content-Type": "application/json" });
		const body = JSON.stringify({ token });
		fetchWithTimeout("/api/user/generateAndChangePassword", {
			method: "POST",
			headers: headers,
			body: body,
		})
			.then((response) => {
				dispatch(userIsLoading(false));

				if (!response.ok) {
					throw Error(response.statusText);
				}

				return response.json();
			})
			.then(() => {
				dispatch(setChangePasswordMessageAction("Votre demande a bien été prise en compte. Vous allez recevoir un nouveau mail dans quelques minutes."));
			})
			.catch((err) => {
				console.error("Erreur : usersActions - validatePasswordChange", err);
				dispatch(userIsLoading(false));
				dispatch(setChangePasswordMessageAction("Une erreur s'est produite. Votre demande ne peut aboutir. Si le problème persiste, veuillez contacter l'administrateur de l'application"));
			});
	}
}
